'use client';

import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@kit/ui/input-group';

export function EmailInput(props: React.ComponentProps<'input'>) {
  const { t } = useTranslation('auth');

  return (
    <InputGroup className="dark:bg-background">
      <InputGroupAddon>
        <Mail className="h-4 w-4" />
      </InputGroupAddon>

      {/* `autoComplete` sits before the spread so a caller can override it —
          sign-in and sign-up both want "email", but a form that ever asks for
          somebody else's address must be able to say so. */}
      <InputGroupInput
        data-test={'email-input'}
        required
        type="email"
        autoComplete="email"
        placeholder={t('emailPlaceholder')}
        {...props}
      />
    </InputGroup>
  );
}
